var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import promotion from '@resources/js/components/promotion';
import { getBcomOrExpediaPartnerType } from '@resources/js/components/promotion/helpers/getPartnerType';
import '@resources/js/analytics';
import NavigationView from '@resources/js/widgets/attraction/navigation/NavigationView_1';
import AuthorInfoView from '@resources/js/widgets/attraction/author-info/AuthorInfoView_1';
import FormView from '@resources/js/components/form/FormView';
import FormStore from '@resources/js/components/form/FormStore';
import FormPresenter from '@resources/js/components/form/FormPresenter';
import handleCalendarFormSubmit from '@resources/js/helpers/handleCalendarFormSubmit';
import { syncFormStoreWithSession } from '@resources/js/components/form/formStoreSync';
import MapView from '@resources/js/maps/MapView';
const partnerType = getBcomOrExpediaPartnerType();
promotion({
    links: {
        active: !!((_b = (_a = window.shared) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.dest_id),
        type: partnerType,
    },
    backbtn: {
        active: !!((_d = (_c = window.shared) === null || _c === void 0 ? void 0 : _c.options) === null || _d === void 0 ? void 0 : _d.bbcl) && !!((_f = (_e = window.shared) === null || _e === void 0 ? void 0 : _e.options) === null || _f === void 0 ? void 0 : _f.dest_id),
        type: partnerType,
    },
    tab_change: {
        active: !!((_h = (_g = window.shared) === null || _g === void 0 ? void 0 : _g.options) === null || _h === void 0 ? void 0 : _h.dest_id),
        type: partnerType,
    },
    popup: {
        active: !!((_k = (_j = window.shared) === null || _j === void 0 ? void 0 : _j.options) === null || _k === void 0 ? void 0 : _k.dest_id),
        type: partnerType,
    },
});
const attractionRootElement = document.querySelector('.js-attraction');
const heroMapElement = attractionRootElement.querySelector('.js-hero-map');
if (heroMapElement) {
    new MapView({
        zoom: 11,
        interactive: false,
    }, { navigation: false });
}
const navWrapElement = attractionRootElement.querySelector('.js-attraction-nav-wrap');
if (navWrapElement)
    new NavigationView(navWrapElement, attractionRootElement);
const authorInfoElement = attractionRootElement.querySelector('.js-author-info');
if (authorInfoElement)
    new AuthorInfoView(authorInfoElement);
// form
const mainFormElement = document.querySelector('.js-form');
const formStore = new FormStore();
syncFormStoreWithSession(formStore);
const mainFormView = new FormView(mainFormElement);
const mainFormPresenter = new FormPresenter(mainFormView, formStore, 'D MMM YYYY');
mainFormPresenter.on('form-submit', formData => handleCalendarFormSubmit({ partnerType, formData }));
